import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "../../components/Button/Button";
import { updatePartenaireKata } from "../../services/partenaireskataServices";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const GRADES = [
  "1er Dan",
  "2ème Dan",
  "3ème Dan",
  "4ème Dan",
  "5ème Dan",
  "6ème Dan",
  "7ème Dan",
  "8ème Dan",
];

const EditPartenaireModal = ({ isOpen, onClose, partenaire, refreshList }) => {
  const [formData, setFormData] = useState({
    club: "",
    passage_grade: "",
    content: "",
    tel: "",
    mail: "",
  });

  useEffect(() => {
    if (partenaire) {
      setFormData({
        club: partenaire.club || "",
        passage_grade: partenaire.passage_grade || "",
        content: partenaire.content || "",
        tel: partenaire.tel || "",
        mail: partenaire.mail || "",
      });
    }
  }, [partenaire]);

  if (!isOpen || !partenaire) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleContentChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updatePartenaireKata({ ...formData, id: partenaire.id });
      await refreshList();
      onClose();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du partenaire", error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-3 sm:px-4">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm"
        onClick={onClose}
      />

      <div
        className="relative max-w-xl w-full bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 p-4 sm:p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-[11px] font-semibold text-primary tracking-[0.25em] uppercase mb-1">
              Partenaire Kata
            </p>
            <h3 className="text-lg sm:text-xl font-bold">
              Éditer le partenaire de Kata
            </h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-700"
          >
            <FaTimes className="w-4 h-4" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-xs font-semibold text-slate-700 dark:text-slate-200 mb-1">
              Club
            </label>
            <input
              type="text"
              name="club"
              placeholder="Nom du club"
              value={formData.club}
              onChange={handleChange}
              className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/70"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-700 dark:text-slate-200 mb-1">
              Grade concerné
            </label>
            <select
              name="passage_grade"
              value={formData.passage_grade}
              onChange={handleChange}
              className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/70"
              required
            >
              <option value="">Choisir le grade</option>
              {GRADES.map((g) => (
                <option key={g} value={g}>
                  {g}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-700 dark:text-slate-200 mb-1">
              Contenu de l&apos;annonce
            </label>
            <ReactQuill
              value={formData.content}
              onChange={handleContentChange}
              className="bg-white dark:bg-slate-800 rounded-lg"
              theme="snow"
              placeholder="Décrivez le niveau souhaité, les disponibilités, le lieu, etc."
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-semibold text-slate-700 dark:text-slate-200 mb-1">
                Contact téléphonique
              </label>
              <input
                type="tel"
                name="tel"
                placeholder="Téléphone"
                value={formData.tel}
                onChange={handleChange}
                className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/70"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-700 dark:text-slate-200 mb-1">
                Contact email
              </label>
              <input
                type="email"
                name="mail"
                placeholder="Email"
                value={formData.mail}
                onChange={handleChange}
                className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/70"
              />
            </div>
          </div>

          <div className="flex justify-center gap-2 pt-2">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              type="button"
              className="btn-ghost gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPartenaireModal;
